import './SelectMulti.scss';

import { Option } from '../../models/generic';
import Select from 'react-select';
import { Props as SelectProps } from 'react-select/';
import { selectIsMobile } from '../../ducks/settings';
import siteMessages from '../../pages/root/siteMessages';
import { useIntl } from 'react-intl';
import { useRef } from 'react';
import { useSelector } from 'react-redux';

interface Props extends SelectProps {
  isMulti?: boolean;
  options?: Option[];
  value?: any;
  onChange: (value: any) => void;
}

const SelectMulti = ({
  isMulti = true,
  options,
  value,
  onChange,
  ...rest
}: Props) => {
  const isMobile = useSelector(selectIsMobile);
  let currentValues: any = [];
  const TAB_KEY_ID = 9;
  const intl = useIntl();
  const NONE = intl.formatMessage({ ...siteMessages.NONE }).toLowerCase();
  const NAMobile = intl
    .formatMessage({ ...siteMessages.NAMobile })
    .toLowerCase();
  const NASocialHabits = intl
    .formatMessage({ ...siteMessages.NASocialHabits })
    .toLowerCase();
  const NAAccessibilities = intl
    .formatMessage({ ...siteMessages.NAAccessibilities })
    .toLowerCase();
  const selectRef = useRef(null);

  const getValue = () => {
    if (options) {
      if (isMulti) {
        currentValues = options.filter(
          (option: Option) =>
            Array.isArray(value) && value.includes(option.value)
        );
      }

      return isMulti
        ? currentValues
        : options.find((option) => option.value === value);
    } else {
      return isMulti ? [] : '';
    }
  };

  const onKeyDown = (e: any) => {
    const ref = selectRef as any;

    if (e.keyCode === TAB_KEY_ID && ref.current.props?.menuIsOpen) {
      ref.current.blur();
      ref.current.focus();
      e.preventDefault();
    }
  };

  const changeValue = (values: any) => {
    return isMulti
      ? values.findIndex((v: Option) => v.label.toLowerCase() === NONE) > -1 ||
        values.findIndex((v: Option) => v.label.toLowerCase() === NAMobile) >
          -1 ||
        values.findIndex(
          (v: Option) => v.label.toLowerCase() === NASocialHabits
        ) > -1 ||
        values.findIndex(
          (v: Option) => v.label.toLowerCase() === NAAccessibilities
        ) > -1
        ? currentValues.findIndex(
            (v: Option) => v.label.toLowerCase() === NONE
          ) > -1 ||
          currentValues.findIndex(
            (v: Option) => v.label.toLowerCase() === NAMobile
          ) > -1 ||
          currentValues.findIndex(
            (v: Option) => v.label.toLowerCase() === NASocialHabits
          ) > -1 ||
          currentValues.findIndex(
            (v: Option) => v.label.toLowerCase() === NAAccessibilities
          ) > -1
          ? onChange(
              values
                .filter(
                  (v: Option) =>
                    v.label.toLowerCase() !==
                    (currentValues.findIndex(
                      (v: Option) => v.label.toLowerCase() === NONE
                    ) > -1
                      ? NONE
                      : currentValues.findIndex(
                          (v: Option) => v.label.toLowerCase() === NAMobile
                        ) > -1
                      ? NAMobile
                      : currentValues.findIndex(
                          (v: Option) =>
                            v.label.toLowerCase() === NASocialHabits
                        ) > -1
                      ? NASocialHabits
                      : NAAccessibilities)
                )
                .map(
                  (v: Option) =>
                    options?.find((option) => option.value === v.value)?.value
                )
            )
          : onChange(
              values.findIndex((v: Option) => v.label.toLowerCase() === NONE) >
                -1
                ? [
                    values.find((v: Option) => v.label.toLowerCase() === NONE)
                      .value
                  ]
                : values.findIndex(
                    (v: Option) => v.label.toLowerCase() === NAMobile
                  ) > -1
                ? [
                    values.find(
                      (v: Option) => v.label.toLowerCase() === NAMobile
                    ).value
                  ]
                : values.findIndex(
                    (v: Option) => v.label.toLowerCase() === NASocialHabits
                  ) > -1
                ? [
                    values.find(
                      (v: Option) => v.label.toLowerCase() === NASocialHabits
                    ).value
                  ]
                : [
                    values.find(
                      (v: Option) => v.label.toLowerCase() === NAAccessibilities
                    ).value
                  ]
            )
        : onChange(
            values.map(
              (v: Option) =>
                options?.find((option) => option.value === v.value)?.value
            )
          )
      : onChange(values.value);
  };

  return (
    <Select
      ref={selectRef}
      isMulti={isMulti}
      isClearable={false}
      closeMenuOnSelect={!isMulti}
      blurInputOnSelect={false}
      isSearchable={!isMobile}
      options={options}
      value={getValue()}
      onKeyDown={(event: any) => onKeyDown(event)}
      onChange={(values: any) => changeValue(values)}
      className="nemo-select-container"
      classNamePrefix="nemo-select"
      {...rest}
    />
  );
};

export default SelectMulti;
